<template>
    <div class="layout">
        <div v-model="drawer" class="layout-drawer" :class="{'drawer-closed': drawerClosed}">
            <div class="sidebar">
                <div class="header">
                    <a
                        v-if="domain"
                        class="header__icon"
                        :href="domain"
                        target="_blank">
                        <img :src="`${domain}/assets/favicon.ico`" width="16" height="16" alt="">
                    </a>
                    <div
                        v-else
                        class="header__icon">
                        <q-icon name="shopping_cart"/>
                    </div>
                    <div class="header__title">{{ project.name }}</div>
                </div>
                <div class="menu">
                    <q-list no-border link inset-delimiter class="menu-list">
                        <q-item :to="'/projects/' + $route.params.id" exact>
                            <q-item-side icon="info"/>
                            <q-item-main label="Детали"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/daily-metrics'">
                            <q-item-side icon="poll"/>
                            <q-item-main label="Метрики за день"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/metrics'">
                            <q-item-side icon="poll"/>
                            <q-item-main label="Метрики за месяц"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/bills'">
                            <q-item-side icon="attach_money"/>
                            <q-item-main label="Счета"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/transactions'">
                            <q-item-side icon="swap_horiz"/>
                            <q-item-main label="Транзакции"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/services'">
                            <q-item-side icon="business_center"/>
                            <q-item-main label="Услуги"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/payment-methods'">
                            <q-item-side icon="account_balance_wallet"/>
                            <q-item-main label="Методы оплаты"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/requisites'">
                            <q-item-side icon="work_outline"/>
                            <q-item-main label="Реквизиты"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/documents'">
                            <q-item-side icon="description"/>
                            <q-item-main label="Договора"/>
                        </q-item>
                        <q-item :to="`/projects/${$route.params.id}/logs`">
                            <q-item-side icon="book"/>
                            <q-item-main label="Логирование <br> действий"/>
                        </q-item>
                        <q-item :to="'/projects/' + $route.params.id + '/acts'">
                            <q-item-side icon="assignment"/>
                            <q-item-main label="Акты"/>
                        </q-item>
                    </q-list>
                </div>
            </div>
            <div class="drawer-handle" @click="drawerMove()">
                <div class="drawer-handle-arrow"></div>
            </div>
        </div>

        <div class="page-container">
            <div class="scroll-container">
                <router-view/>
            </div>
        </div>

    </div>
</template>

<script>
import {
    QBtn,
    QIcon,
    QItem,
    QItemMain,
    QItemSeparator,
    QItemSide,
    QItemTile,
    QLayout,
    QLayoutDrawer,
    QList,
    QListHeader,
    QPage,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
} from 'quasar'
import { mapState } from 'vuex'

export default {
    name: 'home',
    components: {
        QLayout,
        QLayoutDrawer,
        QPageContainer,
        QPage,
        QToolbar,
        QToolbarTitle,
        QBtn,
        QIcon,
        QList,
        QListHeader,
        QItem,
        QItemSide,
        QItemSeparator,
        QItemMain,
        QItemTile,
    },
    data () {
        return {
            projectAvatar: null,
            drawer: true,
            drawerClosed: localStorage.getItem('drawer-closed')
                ? JSON.parse(localStorage.getItem('drawer-closed'))
                : false,
        }
    },
    computed: {
        ...mapState({
            project: state => state.project.data,
        }),
        domain () {
            let domainData = this.getDomain(this.project.domains),
                protocol = domainData && domainData.ssl && domainData.ssl !== 'NONE' ? 'https' : 'http'

            return domainData ? `${protocol}://${domainData.fqdn}` : null
        },
    },
    mounted () {
        this.fetchProject()
    },
    methods: {
        fetchProject () {
            this.$store.dispatch('project/fetchProject', this.$route.params.id).then(() => {
                this.projectAvatar = this.project.name.charAt(0).toUpperCase()
            })
        },
        drawerMove () {
            this.drawerClosed = !this.drawerClosed
            this.$root.$emit('drawer-moved')
            localStorage.setItem('drawer-closed', `${this.drawerClosed}`)
        },
        getDomain (domains) {
            if (!domains) {
                return null
            }

            domains = domains.filter(domain => domain.fqdn_status === 'ASSIGNED')

            let actualDomains = domains.filter(domain => domain.fqdn.indexOf('horoshop') === -1)
            if (actualDomains.length) {
                return _.orderBy(actualDomains, 'sort_order', 'asc')[0]
            } else if (domains.length) {
                return _.orderBy(domains, 'sort_order', 'asc')[0]
            } else {
                return null
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.layout {
    display: flex;
    width: 100%;
    min-height: 100vh;
}

.q-item-side {
    color: #334759;
    text-align: center;
}

.q-item-main {
    color: #334759;
}

.sidebar {
    position: absolute;
    width: 100%;
    height: 100vh;
    background: #F4F5F7;
    display: flex;
    flex-direction: column;
}

.menu {
    flex: 1 1 auto;
}

.menu-list {
    padding: 0;
}

.logo {
    flex: 0 1 auto;
    padding: 30px 25px;

    img {
        width: 140px;
        height: auto;
    }
}

.userbar {
    position: relative;
    flex: 0 1 auto;
    margin: 20px 0;
}

.logout {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
}

.drawer-closed .logout {
    position: static;
}

.profile-link {
    color: inherit;
    text-decoration: none;
}

.header {
    display: flex;
    padding: 20px 16px;
    align-items: center;
    overflow: hidden;

    &__icon {
        display: flex;
        flex-shrink: 0;
        width: 38px;
        height: 38px;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        background: #fff;
        color: #334759;
        font-size: 24px;
    }

    &__title {
        margin-left: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectView.vue